import { ICooperationPartner } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { CooperationPartnerChannel } from 'src/app/business/institution/contracts/cooperation-partner.channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { CooperationPartnerModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class CooperationPartnerSyncService extends SyncService<ICooperationPartner> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<ICooperationPartner>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(CooperationPartnerModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return (
      channel === CooperationPartnerChannel.CREATE ||
      channel === CooperationPartnerChannel.EDIT ||
      channel === CooperationPartnerChannel.DELETE
    );
  }
}
